import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef} from "react";
import {SUMMARY_DEFAULT} from "../../actions/path";
import runningShipImg from '../../assets/running_ship.png'
import Summary from "./index";

const Projects = ({allMode = false}) => {

    // 페이지 이동하려면 사용해야 되는
    const currentPathSelector = useSelector(state => state.pathReducers.currentPath);
    const dispatch
        = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        navigate(currentPathSelector);
    }, [currentPathSelector]);
    // ---------------------------------

    const goToSummartDefault = (e) => {
        e.preventDefault();
        dispatch({type: SUMMARY_DEFAULT});
    }

    const projectList = [
        {
            companyInfo: '소속 회사',
            title: '사내 그룹웨어',
            period: '2024.01 ~ 2024.03',
            content: '사내 솔루션 부서 전용 그룹웨어 (업무 기록, PO사 정보, 계약 관리)',
            skill: 'Java Spring JPA React JS MySQL Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO카드 / OO금융',
            title: 'WCMS 고도화',
            period: '2024.04 ~ 2024.06',
            content: '클라이언트 페이지 구성에 필요한' +
                '데이터를 적재하기 위한 입력 폼 및 API 개발',
            skill: 'Java Spring MyBatis React JS Oracle SVN',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO카드 / OO금융',
            title: 'WCMS 마이그레이션',
            period: '2024.06 ~ 2024.10',
            content: '구 WCMS 로 개발된 입력 폼 및 API → 신규 WCMS 환경에 맞춰 전환 개발',
            skill: 'Java Spring MyBatis React JS Oracle SVN',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO전자',
            title: 'OO전자(글로벌) 대고객 서비스 플랫폼 구축 (지원)',
            period: '2024.11 ~ 2024.12',
            content: '학교, 중소기업 등 특정 대상 타켓 커머스 플랫폼' +
                '- 단위테스트, SIT, UAT 결함 대응 개발',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO전자',
            title: 'OO전자(글로벌) Monthly 매거진 개발 ',
            period: '2025.01 ~ 2025.02',
            content: 'Monthly 매거진 페이지에 필요한 컴포넌트(Magazine) 개발',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO전자',
            title: 'OO전자(글로벌) Monthly 매거진 통합 유지보수',
            period: '2025.03',
            content: 'Monthly 매거진 페이지 전체 컴포넌트 오픈 후 결함 대응 및 수정 요청 건 개발',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO전자',
            title: 'OO전자(글로벌) Monthly 매거진 고도화',
            period: '2025.04',
            content: 'Monthly 매거진 페이지 전체 컴포넌트 추가 개발',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO전자',
            title: 'OO전자(글로벌) 25년 무형상품 판매 서비스 Pilot 구축',
            period: '2025.04 ~ 2025.07',
            content: 'OO전자 무형상품 (제품 관련 보험, 세척) 판매 서비스 중 무형상품 PBP 페이지 개발 (인도)',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO전자',
            title: 'OO전자(글로벌) 무형상품 판매 서비스 RollOut 확산',
            period: '2025.07 ~ 2025.11',
            content: 'OO전자 무형상품 (제품 관련 보험, 세척) 판매 서비스 중 무형상품 PBP 페이지 개발 (멕시코, 베트남, 이탈리아)',
            skill: 'Java React JS AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO전자',
            title: 'OO전자(글로벌) 대고객 플랫폼 Sign-in 개선 프로젝트 (지원)',
            period: '2025.11 ~ 2025.12',
            content: '대고객 플랫폼 로그인 시 통합회원 이메일 인증 여부 확인 API 개발',
            skill: 'Java Spring MyBatis MariaDB Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO전자',
            title: 'OO전자(글로벌) API 표준화',
            period: '2025.12 ~ 2026.3',
            content: '내부 API 표준화',
            skill: 'Java Spring MyBatis MariaDB JS React AEM Git',
            thumbnailPath : '',
        },
        {
            companyInfo: 'OO전자',
            title: 'OO전자(글로벌) SM개발자',
            period: '2026.4 ~',
            content: '고객 서비스 모듈 운영',
            skill: 'Java Spring MyBatis MariaDB JS React AEM Git',
            thumbnailPath : '',
        },
    ]

    const activeTarget = 'choice-summary-2';
    const focusRef = useRef();
    useEffect(() => {
        if (allMode) return;
        document.querySelector(`#${activeTarget}`)?.classList?.add('border-primary');
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    },[])

    return (
        <>
            {!allMode && (
                <Summary/>
            )}
            <main className='container' ref={focusRef}>
                <hr className='featurette-divider'/>
                {!allMode && (
                    <div className='right-align'>
                        <h2><a className='no-line-href margin-right-3vh fold-btn' href='#' onClick={goToSummartDefault}>🔺접기</a></h2>
                    </div>
                )}
                <div className="p-2 rounded text-body-emphasis ">
                    <div className="col-lg-6 px-0">
                        🏢 소속 회사: (주)OO소프트 2024.01 ~ 현재
                    </div>
                </div>
                <div className="row mb-2">
                    {/* 카드 */}
                    {projectList?.slice().reverse().map((item, index) =>
                        <div className={`col-md-6 fade-item ${'delay-'+(index+1)}`}
                            key={`project-${index+1}`}>
                            <div
                                className="bg-color-thistle row g-0 border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
                                <div className="col p-4 d-flex flex-column position-static">
                                    <strong className="d-inline-block mb-2 text-primary-emphasis">
                                        {item?.companyInfo}
                                    </strong>
                                    <h3 className="mb-0">{item?.title}</h3>
                                    <div className="mb-1 text-body-secondary">{item?.period}</div>
                                    <p className="card-text mb-auto">
                                        {item?.content}
                                    </p>
                                    <div
                                        // href="#"
                                        className="font-highlight no-line-href icon-link gap-1 icon-link-hover stretched-link"
                                    >
                                        {item?.skill}
                                        <svg className="bi" aria-hidden="true">
                                            <use xlinkHref="#chevron-right"></use>
                                        </svg>
                                    </div>
                                </div>
                                <div className="col-auto d-none d-lg-block projects-thumbnail">
                                    <img
                                        aria-label="Placeholder: Thumbnail"
                                        className="bd-placeholder-img"
                                        height="250"
                                        preserveAspectRatio="xMidYMid slice"
                                        role="img"
                                        width="200"
                                        // xmlns="http://www.w3.org/2000/svg"
                                        src={runningShipImg}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </>
    );
}

export default Projects;